import React, { Component }  from "react";
import { Button, Glyphicon } from "react-bootstrap";
import uniqueId              from 'lodash/uniqueId';
import ModalProgramSummary   from "../../components/modal/ModalProgramSummary";
import ModalHeroInfo         from "../../components/modal/ModalHeroInfo";
import { WhiteLabel }        from "../../utils/WhiteLabelProps";
import "../../css/marketplace/Marketplace.css";

var white_label               = WhiteLabel();
var previewProgramId          = null;
var previewProgramName        = null;
var previewProgramImgSrc      = null;
var previewProgramSummary     = null;
var previewMktplcId           = null;
var previewProgramLocation    = null;
var previewProgramTotalTime   = null;
var previewProgramDaysPerWeek = null;

const cover_image_custom_url    = white_label.aws_custom_athlete_assets_dashboard_url;
const cover_image_general_url   = white_label.aws_general_athlete_assets_url;
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";

export default class AthleteMarketplace extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elapsed: 0,
            showModalProgramSummary: false,
            showModalHeroInfo: false,
            presetProgramId: this.props.presetProgramId //"25bf7a60-9c94-11ea-826f-89faa507940c"
        };
    }

    handleOpenModalProgramSummary = ( mktplc_id, program_id, title, summary, image, location, total_time, days_per_week) => {
        this.setState({
            marketplaceId:  mktplc_id,
            programId:     program_id,
            programTitle:   title,
            programImage:   image,
            programSummary: summary,
            programLocation: location,
            programTotalTime: total_time,
            programDaysPerWeek: days_per_week,
            showModalProgramSummary: true
        })
    }

    componentDidMount () {
        //console.log("------------- previewProgramId: " + previewProgramId);

        if(previewProgramId != null) {
            var program_name = previewProgramName;
            var program_id   = previewProgramId;
            var img_src      = this.getCoverImageURL(previewProgramImgSrc);
            var summary      = previewProgramSummary;
            var mktplc_id    = previewMktplcId; //"c39d6d26-9cdc-11ea-9b01-e75e3806fa3e";
            var location     = previewProgramLocation;
            var total_time   = previewProgramTotalTime;
            var days_per_week= previewProgramDaysPerWeek;

            //console.log("RESET PREVIEW SUMMARY PROGRAM ID from PH");
            localStorage.setItem('previewMktplcProgramId', undefined);

            this.handleOpenModalProgramSummary(mktplc_id, program_id, program_name, summary, img_src, location, total_time, days_per_week);
        }
    }


    getCoverImageURL = (img_src) => {
        var company_id = localStorage.getItem('globalUserCompanyId');
        var custom_cover_image  = cover_image_custom_url + img_src;
        var general_cover_image = cover_image_general_url + img_src;
        var image = general_cover_image;
        // id: 1 = Posture Health athlete marketplace
        // id: 2 = Generic images on dashboard
        if(company_id == posture_health_company_id)
            image = custom_cover_image;

        return image;
    }

    getThumbs (mktplc_id, program_id, image, summary, program_name, location, total_time, days_per_week) {

        var img_src     = this.getCoverImageURL(image);
        var thumb = <span key = {uniqueId()}
                          className="marketplaceThumbsContainer"
                          onClick= {this.handleOpenModalProgramSummary.bind(this, mktplc_id, program_id, program_name, summary, img_src, location, total_time, days_per_week)}>
                           <span className="marketplaceThumbBox">
                               <img src={img_src}
                                    className="marketplaceCategoryThumbnail"/>
                           </span>
                           <span className="marketplaceCategoryThumbnailTitle">
                              {program_name}
                           </span>
                           <span className="marketplaceCategoryThumbnailSubTitle">
                               Time: {total_time}
                           </span>
                           <span>
                                <img src={require('../../images/thumbs/thumb_white_overlay.png')}
                                     className="marketplaceThumbsOverlay"/>
                           </span>
                           <span className="marketplaceThumbnailHorSpacer" />
                      </span>
        return thumb;
    }

    getThumbContainer (category_name, program_arr) {
        var div_program_arr       = [];

        var preset_program_id = this.state.presetProgramId;
        for(var i=0; i< program_arr.length; i++) {
            var temp_category_name = program_arr[i][0];
            var program_name  = program_arr[i][1];
            var program_id    = program_arr[i][2];
            var image         = program_arr[i][3];
            var summary       = program_arr[i][4];
            var mktplc_id     = program_arr[i][5];
            var location      = program_arr[i][6];
            var total_time    = program_arr[i][7];
            var days_per_week = program_arr[i][8];


            if(program_id === preset_program_id) {
                previewProgramId          = program_id;
                previewProgramName        = program_name;
                previewProgramImgSrc      = image;
                previewProgramSummary     = summary;
                previewMktplcId           = mktplc_id;
                previewProgramLocation    = location;
                previewProgramTotalTime   = total_time;
                previewProgramDaysPerWeek = days_per_week;
            }
            ////   Compare categories and only show associated programs   ////
            if(category_name == temp_category_name) {
                if(image == null ) image = "default.jpg"
                div_program_arr.push(this.getThumbs(mktplc_id, program_id, image, summary, program_name, location, total_time, days_per_week))
            }
        }

        return div_program_arr;
    }
    getCategory () {
        var category_arr      = [];
        var category_name_arr = [];
        var program_arr       = [];
        var all_programs      = this.props.allMktplcPrograms;

        for(var key in all_programs) {
            var mktplc_id      = all_programs[key].mktplc_id;
            var category_name  = all_programs[key].category_name;
            var program_name   = all_programs[key].program_name;
            var program_id     = all_programs[key].program_id;
            var summary        = all_programs[key].summary;
            var program_image  = all_programs[key].program_image;
            var location       = all_programs[key].location;
            var total_time     = all_programs[key].total_time;
            var days_per_week  = all_programs[key].days_per_week;

            /*console.log("---------------------------------");
            console.log("program_name: " + program_name);
            console.log("program_id: " + program_id);*/

            var cat_exists = category_name_arr.includes(category_name);
            if(!cat_exists)
                category_name_arr.push(category_name)

            program_arr.push([category_name, program_name, program_id, program_image, summary, mktplc_id, location, total_time, days_per_week])
        }

        for(var i=0; i< category_name_arr.length; i++) {
            var category_name = category_name_arr[i];

            category_arr.push(<div key={ uniqueId()} className="marketplaceRowContainer dashboardCardsTour">
                                <div className="marketplaceCategoryTitle">{category_name}</div>
                                    <span className="marketplaceRowPrograms">
                                     { this.getThumbContainer(category_name, program_arr) }
                                    </span>
                              </div>)
        }

        return category_arr;
    }

    handleLearnMoreModal = () => {
        this.setState({
            showModalHeroInfo: true
        })
    }

    render() {

        var primary_color = "#00b3e0"; //"#00dfa1";
        let closeModalProgramSummary = () => this.setState({ showModalProgramSummary: false }); //close simple modal window
        let closeModalHeroInfo       = () => this.setState({ showModalHeroInfo: false }); //close simple modal window
        var img_hero_src             = this.getCoverImageURL("hero_posture.jpg");

        return  <span className="">
                    <div className="marketplaceHeroImageContainer" onClick={this.handleLearnMoreModal}>
                        <span className="marketplaceMainCarouselTitle">
                             Our Exercise Programs
                        </span>
                        <span className="marketplaceMainCarouselTitleBkgrd" style={{backgroundColor: primary_color}}/>
                         <span>
                             <img src={img_hero_src}
                                 className="marketplaceMainCarouselImage"/>
                         </span>
                    </div>

                    <div className="">
                        { this.getCategory() }
                    </div>

                    <div className="ppFooter">
                        <a href='/privacypolicyauth' onClick={this.props.handlePrivacyToS}>Privacy Policy</a>&nbsp; |  &nbsp;<a href='/tosauth' onClick={this.handlePrivacyToS}>Terms of Service</a>
                    </div>
                    {this.state.showModalProgramSummary ?
                        <ModalProgramSummary
                            show               = { this.state.showModalProgramSummary }
                            onHide             = { closeModalProgramSummary }
                            marketplaceId      = { this.state.marketplaceId }
                            programId          = { this.state.programId}
                            programImage       = { this.state.programImage }
                            programTitle       = { this.state.programTitle }
                            programSummary     = { this.state.programSummary }
                            programSubscribed  = { this.props.programSubscribed }
                            programLocation    = { this.state.programLocation }
                            programTotalTime   = { this.state.programTotalTime }
                            programDaysPerWeek = { this.state.programDaysPerWeek }
                            handleSubscribeToMktplcProgram = { this.props.handleSubscribeToMktplcProgram }
                        />
                    : null}
                    {this.state.showModalHeroInfo ?
                        <ModalHeroInfo
                            show               = { this.state.showModalHeroInfo }
                            onHide             = { closeModalHeroInfo }
                        />
                    : null}
                </span>
    }
}



// WEBPACK FOOTER //
// ./src/components/marketplace/AthleteMarketplace.js